import type { WhatsNewEntryI } from "../lib/types";

import { ADMIN_REP_WORKSPACES_2026_10_27 } from "./2026-10-27-admin-rep-workspaces";
import { BLOCK_SYSTEM_2026_10_26 } from "./2026-10-26-block-system";
import { INCENTIVES_2026_10_27 } from "./2026-10-27-incentives";
import { PIPELINE_2026_10_27 } from "./2026-10-27-pipeline";
import { PIPELINE_BULK_EDIT_2026_10_28 } from "./2026-10-28-pipeline-bulk-edit";
import { FORECAST_2026_10_28 } from "./2026-10-28-forecast";
import { CAMPAIGN_HEALTH_EXTRAS_2026_10_28 } from "./2026-10-28-campaign-health-extras";
import { LEAD_INGESTION_2026_10_28 } from "./2026-10-28-lead-ingestion";
import { PAGE_UPDATES_2026_10_28 } from "./2026-10-28-page-updates";
import { EOM_2026_11 } from "./2026-11-eom";
import { EOM_CLOSE_TOOLS_2026_11 } from "./2026-11-eom-close-tools";
import { EOM_CLOSE_CHECKS_2026_11 } from "./2026-11-eom-close-checks";
import { ALL_WORKSPACES_HEALTH } from "./all-workspaces-health";

/**
 * Every static "What's new" entry, newest last. A release that changes what
 * a role sees adds one file here (Omar, 2026-10-25: "Anytime you're doing
 * something new, there should be a widget"). Entries stay after they expire;
 * prune the old ones whenever convenient.
 */
export const WHATS_NEW_ENTRIES: Array<WhatsNewEntryI> = [
  BLOCK_SYSTEM_2026_10_26,
  PIPELINE_2026_10_27,
  INCENTIVES_2026_10_27,
  ADMIN_REP_WORKSPACES_2026_10_27,
  FORECAST_2026_10_28,
  PIPELINE_BULK_EDIT_2026_10_28,
  CAMPAIGN_HEALTH_EXTRAS_2026_10_28,
  LEAD_INGESTION_2026_10_28,
  EOM_2026_11,
  PAGE_UPDATES_2026_10_28,
  ALL_WORKSPACES_HEALTH,
  EOM_CLOSE_TOOLS_2026_11,
  EOM_CLOSE_CHECKS_2026_11,
];
